import SockJS from "sockjs-client/dist/sockjs.min";
import { Client } from "@stomp/stompjs";

document.addEventListener("DOMContentLoaded", function () {
  const token = window.videocallConfig?.token;
  const turnUrl = window.videocallConfig?.turnUrl;
  const turnUsername = window.videocallConfig?.turnUsername;
  const turnSecret = window.videocallConfig?.turnSecret;

  if (!token) return;

  const localVideo = document.getElementById("localVideo");
  const remoteVideo = document.getElementById("remoteVideo");
  const statusOverlay = document.getElementById("statusOverlay");
  const statusText = document.getElementById("statusText");

  let localStream;
  let peerConnection;
  let stompClient;

  const configuration = {
    iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
  };

  if (turnUrl && turnUsername && turnSecret) {
    configuration.iceServers.push({
      urls: turnUrl,
      username: turnUsername,
      credential: turnSecret,
    });
  }

  async function init() {
    try {
      // 1. Get Camera/Mic
      statusText.innerText = "Kamera wird gestartet...";
      localStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      localVideo.srcObject = localStream;

      // 2. Connect to WebSocket Signaling
      statusText.innerText = "Verbinde mit Server...";
      connectSignaling();
    } catch (err) {
      console.error("Error accessing media devices.", err);
      statusText.innerText =
        "Kamera/Mikrofon konnte nicht gestartet werden. Bitte Berechtigungen prüfen.";
      document.querySelector(".spinner-border").style.display = "none";
    }
  }

  function connectSignaling() {
    const socket = new SockJS("/ws", null, {
      transports: ["websocket"],
    });

    stompClient = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,
      debug: (str) => console.log("[Public WebSocket]", str),
      onConnect: () => {
        console.log("Connected to signaling server");
        statusText.innerText = "Warte auf Berater...";

        stompClient.subscribe("/topic/videocall/" + token, function (message) {
          handleSignalingMessage(JSON.parse(message.body));
        });

        // Notify advisor that lead joined
        sendSignal({
          type: "JOIN",
          sender: "LEAD",
        });
      },
      onStompError: (frame) => {
        console.error("STOMP error", frame.headers["message"]);
        statusText.innerText = "Verbindungsfehler.";
      },
      onWebSocketError: (event) => {
        console.error("WebSocket connection error", event);
        statusText.innerText = "Verbindungsfehler.";
      },
    });

    stompClient.activate();
  }

  function sendSignal(msg) {
    if (stompClient && stompClient.connected) {
      stompClient.publish({
        destination: "/app/videocall/signal/" + token,
        body: JSON.stringify(msg),
      });
    }
  }

  async function handleSignalingMessage(msg) {
    if (msg.sender === "LEAD") return; // Ignore our own messages

    switch (msg.type) {
      case "JOIN":
        // Advisor joined.
        statusText.innerText = "Berater ist beigetreten.";
        break;
      case "OFFER":
        console.log("Received Offer");
        await handleOffer(msg.offer);
        break;
      case "ANSWER":
        console.log("Received Answer");
        // Advisor sends answer if lead was initiator, but here Advisor is initiator
        break;
      case "ICE":
        console.log("Received ICE candidate");
        if (peerConnection && msg.candidate) {
          try {
            await peerConnection.addIceCandidate(msg.candidate);
          } catch (e) {
            console.error("Error adding received ice candidate", e);
          }
        }
        break;
      case "LEAVE":
        endCallLocally();
        break;
    }
  }

  function createPeerConnection() {
    peerConnection = new RTCPeerConnection(configuration);

    // Add local stream tracks
    localStream.getTracks().forEach((track) => {
      peerConnection.addTrack(track, localStream);
    });

    // Handle incoming stream
    peerConnection.ontrack = (event) => {
      console.log("Received remote track");
      statusOverlay.style.display = "none";
      if (!remoteVideo.srcObject) {
        remoteVideo.srcObject = event.streams[0];
      }
    };

    // Handle ICE candidates
    peerConnection.onicecandidate = (event) => {
      if (event.candidate) {
        sendSignal({
          type: "ICE",
          sender: "LEAD",
          candidate: event.candidate,
        });
      }
    };

    peerConnection.onconnectionstatechange = () => {
      if (
        peerConnection.connectionState === "disconnected" ||
        peerConnection.connectionState === "failed"
      ) {
        endCallLocally();
      }
    };
  }

  async function handleOffer(offer) {
    if (!peerConnection) {
      createPeerConnection();
    }
    try {
      await peerConnection.setRemoteDescription(new RTCSessionDescription(offer));
      const answer = await peerConnection.createAnswer();
      await peerConnection.setLocalDescription(answer);
      sendSignal({
        type: "ANSWER",
        sender: "LEAD",
        answer: answer,
      });
    } catch (e) {
      console.error("Error handling offer", e);
    }
  }

  function endCallLocally() {
    if (peerConnection) {
      peerConnection.close();
      peerConnection = null;
    }
    if (localStream) {
      localStream.getTracks().forEach((track) => track.stop());
    }
    if (stompClient) {
      stompClient.deactivate();
    }
    statusOverlay.style.display = "flex";
    statusText.innerText = "Der Anruf wurde beendet.";
    document.querySelector(".spinner-border").style.display = "none";
    sendSignal({ type: "LEAVE", sender: "LEAD" });
  }

  // Controls
  let micEnabled = true;
  document.getElementById("toggleMicBtn").addEventListener("click", function () {
    micEnabled = !micEnabled;
    if (localStream) {
      localStream.getAudioTracks().forEach((track) => (track.enabled = micEnabled));
    }
    this.innerHTML = micEnabled
      ? '<i class="bi bi-mic-fill fs-4"></i>'
      : '<i class="bi bi-mic-mute-fill fs-4"></i>';
    this.classList.toggle("active", !micEnabled);
  });

  let camEnabled = true;
  document.getElementById("toggleCamBtn").addEventListener("click", function () {
    camEnabled = !camEnabled;
    if (localStream) {
      localStream.getVideoTracks().forEach((track) => (track.enabled = camEnabled));
    }
    this.innerHTML = camEnabled
      ? '<i class="bi bi-camera-video-fill fs-4"></i>'
      : '<i class="bi bi-camera-video-off-fill fs-4"></i>';
    this.classList.toggle("active", !camEnabled);
  });

  document.getElementById("endCallBtn").addEventListener("click", endCallLocally);

  // Start everything
  window.addEventListener("load", init);
});
